module.exports = __webpack_public_path__ + "img/more.3b2ccd24.png";